import { getCookie } from '@/utils/cookie'
import Url from '@mc/mc-utils/js/url/url'
import { miniProgramEnv } from '@/defines/environment/getters/detect_mp'
import { platform } from '@/defines/environment'

const getTicketsFromUrl = () => {
  const url = new Url(window.location.href)
  const { tickets } = url.parseQuerystring()
  return tickets
}

export const getTickets = userInfo => {
  switch (true) {
    case platform === 'ios' || platform === 'android':
      return userInfo.tickets ? decodeURIComponent(userInfo.tickets) : ''
    case miniProgramEnv.isMiniProgram:
      return getTicketsFromUrl()
    default:
      return getTicketsFromUrl() || getCookie('mc_loguser_tickets')
  }
}
